import { RouteObject } from "react-router";
import { CertificatesRoute } from "@/routes/processes/[processId]/rlt/certificates/certificates-route";
import { CertificateRoute } from "@/routes/processes/[processId]/rlt/certificates/[certificateId]/certificate-route";

export const certificatesRoutes: RouteObject[] = [
  {
    index: true,
    element: <CertificatesRoute />,
  },
  {
    path: ":certificateId",
    element: <CertificateRoute />,
  },
];
